import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import heroImage from "../assets/img/hero-02.jpg";

const HeroSection = () => {
    return (
      <HeroContainer>
        <Background
          initial={{ scale: 1.2 }}
          animate={{ scale: 1 }}
          transition={{ duration: 3, ease: "easeOut" }}
        />
        <Overlay />
        <Content>
          <motion.div
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, ease: "easeOut" }}
          >
            <Tagline>Engineering Solutions, Building Trust</Tagline>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.5, ease: "easeOut" }}
          >
            <Description>
              TERSA is your trusted partner in delivering innovative Mechanical, Electrical, and Civil solutions for industrial, commercial, and residential projects.
            </Description>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, delay: 1, ease: "easeOut" }}
          >
            <ButtonGroup>
              <CTAButton href="#services">Explore Services</CTAButton>
              <SecondaryButton href="#contact">Get a Quote</SecondaryButton>
            </ButtonGroup>
          </motion.div>
        </Content>
      </HeroContainer>
    );
  };
  
  // Styled Components
  const HeroContainer = styled(motion.section)`
    position: relative;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #f3f6fb;
    overflow: hidden;
  `;
  
  const Background = styled(motion.div)`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${heroImage});
    background-size: cover;
    background-position: center;
    z-index: 0;
  `;
  
  const Overlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 51, 0.6); /* Dark overlay */
    z-index: 1;
  `;
  
  const Content = styled.div`
    position: relative;
    z-index: 2; /* Ensure content is above the overlay */
    max-width: 800px;
    margin: auto;
    text-align: center;
  `;
  
  const Tagline = styled.h1`
    font-size: 3rem;
    margin-bottom: 20px;
    font-weight: bold;
    text-transform: uppercase;
  
    @media (max-width: 768px) {
      font-size: 2rem;
    }
  `;
  
  const Description = styled.p`
    font-size: 1.2rem;
    line-height: 1.6;
    margin-bottom: 40px;
  
    @media (max-width: 768px) {
      font-size: 1rem;
    }
  `;
  
  const ButtonGroup = styled.div`
    display: flex;
    justify-content: center;
    gap: 20px;
  `;
  
  const CTAButton = styled.a`
    padding: 12px 30px;
    background-color: #ffa500;
    color: #003366;
    text-decoration: none;
    font-size: 1.2rem;
    font-weight: bold;
    border-radius: 5px;
    transition: background-color 0.3s;
  
    &:hover {
      background-color: #ffcc00;
    }
  `;
  
  const SecondaryButton = styled.a`
    padding: 12px 30px;
    background-color: transparent;
    color: #f3f6fb;
    text-decoration: none;
    font-size: 1.2rem;
    font-weight: bold;
    border: 2px solid #f3f6fb;
    border-radius: 5px;
    transition: color 0.3s, background-color 0.3s;
  
    &:hover {
      background-color: #ffa500;
      color: #003366;
    }
  `;
  
  export default HeroSection;